// API Configuration
export interface ApiConfig {
  baseUrl: string;
  apiKey: string;
  menuKey: string;
  menuVersion: string;
}

// Environment configurations
const configs: Record<string, ApiConfig> = {
  staging: {
    baseUrl: 'https://api-stage.spurcorp.io/v1.0',
    apiKey: 'cbca11da7d5b4851ad9ae39f8f5136a1',
    menuKey: 'Pana-za-78',
    menuVersion: '202504'
    //  menuKey: 'SPUR-ZA-19',
    // menuVersion: '202507'
  },
  production: {
    baseUrl: 'https://api.spurcorp.io/v1.0',
    apiKey: 'cbca11da7d5b4851ad9ae39f8f5136a1',
    menuKey: 'PANA-ZA-26',
    menuVersion: 'current'
  }
};

// Current environment - change this to switch between staging and production
const currentEnvironment: string = 'staging';

// Export the current configuration
export const apiConfig: ApiConfig = configs[currentEnvironment];

// Helper function to get the menu endpoint URL
export const getMenuEndpoint = (): string => {
  return `${apiConfig.baseUrl}/menus/${apiConfig.menuKey}/${apiConfig.menuVersion}/items`;
};

// Helper function to get API headers
export const getApiHeaders = (): Record<string, string> => {
  return {
    'X-API-Key': apiConfig.apiKey,
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };
}; 